<template>
	<div class="cropper_wrap">
		<div class="cropper" :style="{'width': cropperW + 'px', 'height': cropperH + 'px'}">
			<vueCropper ref="cropper" :img="cropperUrl" :output-size="option.size" :output-type="option.outputType"
				:info="true" :full="option.full"  :can-move="option.canMove"
				:can-move-box="option.canMoveBox" :fixed-box="option.fixedBox" :original="option.original"
				:auto-crop="option.autoCrop" :auto-crop-width="option.autoCropWidth"
				:auto-crop-height="option.autoCropHeight" :center-box="option.centerBox" :canScale="false"
				:high="option.high" mode="cover" @realTime="realTime"></vueCropper>
		</div>
		<!-- <el-button @click="uploadImg" size="small" type="primary">保存</el-button> -->
	</div>
</template>
<script>
	export default {
		name: 'ImgCropper',
		props: {
			cropperW: {
				type: [Number, String],
				default: 225
			},
			cropperH: {
				type: [Number, String],
				default: 300
			},
			cropperUrl: {
				type: String,
				default: ''
			},
			ratio: {
				type: Array,
				default: () => [3, 4]
			},
			fileType: {
				type: String,
				default: 'png'
			}
		},
		data() {
			return {
				crap: false,
				previews: {},
				option: {
					size: 1,
					full: true,
					outputType: 'png',
					canMove: true,
					fixedBox: true,
					original: false,
					canMoveBox: false,
					autoCrop: true,
					// 只有自动截图开启 宽度高度才生效
					autoCropWidth: 160,
					autoCropHeight: 150,
					centerBox: true,
					high: true,
					max: 99999
				},
				downImg: '#'
			}
		},
		methods: {
			uploadImg() {
				// console.log(this.$refs.cropper)
				// this.$refs.cropper.getImgAxis((a,b,c) => {
				// 	console.log(a,b,c, 'pppreere')
				// })
				this.$refs.cropper.getCropBlob((data, q,b) => {
					this.$emit('coverFinsh', data)
				})
			},
			imgLoad(msg) {
				// console.log(msg)
			},
			changeScale(num) {
				this.$refs.cropper.changeScale(num)
			},
			realTime(item) {
				this.$emit('realTime', item)
			}
		},
		watch: {
			cropperW: {
				immediate: true,
				handler(news) {
					let max = Math.max(this.ratio)
					// 750, 500  400/ 300
					// 276 250 
					let ratio = 0
					if (this.cropperH > this.cropperW) {
						ratio = this.cropperW / this.ratio[0] * this.ratio[1] > this.cropperH ? this.cropperW / this.ratio[
							1] : this.cropperW / this.ratio[0]
					} else {
						ratio = this.cropperH / this.ratio[1] * this.ratio[0] > this.cropperW ? this.cropperH / this.ratio[
							0] : this.cropperH / this.ratio[1]
					}
					this.option.autoCropHeight = parseInt(ratio * this.ratio[1])
					this.option.autoCropWidth = parseInt(ratio * this.ratio[0])
				}

			}
		}
	}
</script>
<style lang="less" scoped>
</style>
